
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";

import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { PROD, PIT_ROLES } from "../../../common/constants";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { authKey, DOWNLOAD_DOCUMENT, GET_SES_LIST, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';
import jwt from 'jwt-decode';
import SearchIcon from "@mui/icons-material/Search";
import './grnList.css';
import moment from 'moment';
import { Button, Box, Card, CardContent, Typography, IconButton, Tooltip, Link } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function SESList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
  const [asnDetails, setAsnDetails] = useState([]);
  const [selected, setSelected] = useState(asnDetails);
  const [searchFilter, setSearchFilter] = useState({
    "consignmentNo": "",
    "grnDate": "",
    // "materialtype":""
  });
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [sesListData, setSesListData] = useState();
  const [userRole, setUserRole] = useState();
  const location = useLocation();
  const [temp, setTemp] = useState();


  const onViewDetails = (cellValues) => {
    navigate('./sesDetailsScreen', {
      state: { selectedRow: cellValues.row, tabValue: tabValue, pageName: "sesList" }
    });
  }

  useEffect(() => {
    setUserRole(location?.state?.data);
  }, []);


  useEffect(() => {
    if (decoded.extension_URN) {
      getStakeDetails();
    } else {
      getSesList();
    }
  }, []);

  function getStakeDetails() {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        getSesList(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {

    setSesListData([]);

  }, [stakeholderDetails?.category ? stakeholderDetails?.category : ""]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    getSesList(stakeholderDetails, newValue)
  };

  const getSesList = (stakeholderData, materialType) => {
    loaderService.showLoader();
    apiClient
      .post(GET_SES_LIST,
        {
          "sesNo": "",
          "stakeholderUrn": stakeholderData?.urn ? stakeholderData?.urn : '',
          "stakeholderType": stakeholderData?.category ? stakeholderData.category : "",
          "consignmentNo": "",
          "sesDate": "",
          "materialType": materialType ? materialType : tabValue,
          // "stakeholderUrn": stakeholderDetails?.urn,
          // "stakeholderType":stakeholderCat ? stakeholderCat : (stakeholderDetails?.category ? stakeholderDetails?.category : ""),
          // "consignmentNo": searchFilter?.consignmentNo ? searchFilter?.consignmentNo : null,
          // "grnDate": searchFilter?.grnDate ? searchFilter?.grnDate : null
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSesListData(response.data.sesList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
    loaderService.showLoader();
    return fetch(DOWNLOAD_DOCUMENT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        AuthKey: authKey,
      },
      body: JSON.stringify({
        "fileName": documentBlobName,
        "containerName": "pit",
        "file": ""
      })
    })
      .then((response) => response.blob())
      .then((blob) => {
        if (type === "View") {
          const fileName = finalfileName || "";
          const splittedName = fileName.split('.');
          const fileExtension = splittedName[splittedName.length - 1]?.toLowerCase();
          let fileType;
          switch (fileExtension) {
            case 'pdf':
              fileType = 'application/pdf';
              break;
            case 'png':
              fileType = 'image/png';
              break;
            case 'jpg':
            case 'jpeg':
              fileType = 'image/jpeg';
              break;
            default:
              fileType = 'application/octet-stream';
          }
          const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
          const newWindow = window.open(url, '_blank');
          if (newWindow) newWindow.focus();
        }
        else {
          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = finalfileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };


  const columns = [
    { field: 'sesNo', headerName: 'SES No', width: 150 },
    { field: 'invoiceNo', headerName: 'Invoice No', width: 150 },
    {
      field: 'soNo', headerName: 'SO Number', width: 150,
      // renderCell: (params) => {
      //   return (
      //     <>{params?.row?.sesGrnDetailsList?.[0]?.poNo}</>
      //   );
      // },
      // valueGetter: (params) => params?.row?.sesGrnDetailsList?.[0]?.poNo
    },
    { field: 'sesStakeholderType', headerName: 'SES Stakeholder Type', width: 170 },
    { field: 'destinationTotalWeight', headerName: 'SES Quantity (MT)', width: 150 },
    {
      field: 'invoiceAmount', headerName: 'SES Amount(in Rs)', width: 150,
      valueGetter: (params) => {
        return Number(params?.value).toFixed(4);

      }
      // valueFormatter: () => "MT"
    },
    { field: 'sesType', headerName: 'Material Type', width: 150 },
    {
      field: 'sesDate', headerName: 'SES Date', width: 130,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    // { field: 'pickupTotalWeight', headerName: 'PickUp Quantity (MT)', width: 140 },
    { field: 'deliveryStakeholderName', headerName: 'First Party Name', width: 140, hide: !(userRole === PIT_ROLES.PitScmUser && true) },
    { field: 'deliveryStakeholderUrn', headerName: 'First Party URN', width: 150, hide: !(userRole === PIT_ROLES.PitScmUser && true) },
    {
      field: 'invoiceDocuments',
      headerName: "Invoice Documents",
      width: 260,
      renderCell: (params) => {
        const docs = params.value || [];
        if (!docs || docs.length === 0) return <Typography variant="caption">No Documents</Typography>;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
            {docs.map((doc, idx) => (
              <Box key={doc.invoiceFileId || idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Link
                  component="button"
                  variant="body2"
                  onClick={(e) => {
                    e.preventDefault();
                    viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "View");
                  }}
                  underline="hover"
                  sx={{ cursor: 'pointer', fontSize: '0.8rem' }}
                >
                  {doc.invoiceFileName}
                </Link>
                <Button
                  size="small"
                  variant="text"
                  onClick={() => viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "Download")}
                  sx={{ minWidth: 'auto', p: 0, fontSize: '0.7rem', textTransform: 'none' }}
                >
                  Download
                </Button>
              </Box>
            ))}
          </Box>
        );
      }
    },
    {
      field: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View">
            <IconButton
              color="primary"
              onClick={() => onViewDetails(cellValues)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  //   const handleDateChange = (date) => {
  //     setPickUpDate(date);
  //     // getconsignmentDetails(date);
  // }
  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT18</p>}
        <Typography variant="h4" gutterBottom>SES List</Typography>
        <Card>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange}>
                <Tab label="Raw Bamboo" value="RawBamboo" />
                <Tab label="Chip Bamboo" value="ChipBamboo" />
              </TabList>
            </Box>
            <TabPanel value="RawBamboo">
              <Box style={{ height: 500, width: '100%' }}>
                {
                  sesListData &&
                  <DataGrid rows={sesListData}
                    columns={columns}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }
              </Box>
            </TabPanel>
            <TabPanel value="ChipBamboo">
              <Box style={{ height: 500, width: '100%' }}>
                {
                  sesListData &&
                  <DataGrid rows={sesListData}
                    columns={columns}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }
              </Box>
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </>
  );
}
export default SESList;
